"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Authenticated User API
 * # Introduction The purpose of this API is to fetch user information using the IST JWT token header. # Changelog   ## 1.2   - Migrated to OpenApi specification    ## 1.1   - Added \'translations\' and \'settings\' to the User
 *
 * The version of the OpenAPI document: 1.2
 * Contact: info@ist.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
